import * as d3 from "d3";
import {
    addGridlines, axisTextDim1,
    colonAnnotation, contextMenu, createTooltip,
    fw_progressive_1way, generateDownloadData,
    inrFormatter,
    responsivefy,
    // XaxisAttribute
} from '../functions'

export default function (chart, divId,vizName, resData,filterParam,checkbox,gridflag) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = chart.axisLabelFontSize + "px"
    //var tempVar = chart.tempVar

    // append the svg object to the body of the page
    var svg = d3.select(divId).select("svg").remove();
    svg = d3.select(divId)
        .append('svg')
        .attr('width', chart.width + chart.margin.left + chart.margin.right)
        .attr('height', chart.height + 5 * chart.margin.top + chart.margin.bottom)
        .call(responsivefy)
        .append('g')
        .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')

    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName


    // axios.post(url, filterParam).then(res => {
        let data = resData;
        // Compute quartiles, median, inter quantile range min and max --> these info are then used to draw the box.
        var sumstat = d3.nest()
            .key((d) => {
                return d.dim1_name
            })
            .rollup((d) => {
                let q1;
                q1 = d3.quantile(d.map(function (g) {
                    return g.metric1
                })
                    .sort(d3.ascending), .25)

                let median;
                median = d3.quantile(d.map(function (g) {
                    return g.metric1
                })
                    .sort(d3.ascending), .5)

                let mean;
                mean = d3.mean(d.map(function (g) {
                    return g.metric1;
                }))

                let q3;
                q3 = d3.quantile(d.map(function (g) {
                    return g.metric1
                }).sort(d3.ascending), .75)

                let interQuantileRange, min, max;
                interQuantileRange = q3 - q1
                min = q1 - interQuantileRange
                max = q3 + interQuantileRange
                return ({
                    q1: q1,
                    median: median,
                    mean: mean,
                    q3: q3,
                    interQuantileRange: interQuantileRange,
                    min: min,
                    max: max
                })
            }).entries(data)

        // Show the X and Y scale
        var x1Scale = d3.scaleBand()
            .rangeRound([0, chart.width])
            .domain(data.map(d => {
                return d.dim1_name
            }))
            .paddingInner(1)
            .paddingOuter(.5)
        var y1Scale = d3.scaleLinear().domain([0, d3.max(data, d => {
            return +d.metric1
        })]).range([chart.height, 0])
        var metric1ColorScale = d3.scaleOrdinal().range(fw_progressive_1way)
        if (gridflag === true) {
            addGridlines(svg, x1Scale, y1Scale, chart);
        }
        svg.append('g')
            .attr('transform', 'translate(0,' + chart.height + ')')
            .call(d3.axisBottom(x1Scale))
            .style('font-size', axisLabelFontSize)
            .selectAll('text')
            .style('text-anchor', 'end')
            // .attr('dx', XaxisAttribute)
            .attr('transform', 'rotate(-50)')
            .text(axisTextDim1)

        svg.append('g').call(d3.axisLeft(y1Scale).tickFormat(inrFormatter)).style('font-size', axisLabelFontSize)

        svg.append('text')
            .attr('x', (chart.width / 3))
            .attr('y', chart.height + chart.margin.bottom + 20 * chart.axisLabelDistance)
            .style('fill', fontColor)
            .text(chart.x1AxisDisplayName)
            .style('font-size', fontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chart.margin.left)
            .attr('x', 0 - (chart.height / 2))
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .style('fill', fontColor)
            .text(chart.y1AxisDisplayName)
            .style('font-size', fontSize)

        /*d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element
            var y1tip = tooltip_class()

            y1tip.attr('class', 'd3-tip'+divId.id)
                .html(function (d) {
                    return (d.key
                        + '<br> Max'+colonAnnotation + inrFormatter(d.value.max)
                        + '<br> Q3'+colonAnnotation + inrFormatter(d.value.q3)
                        + '<br> Median'+colonAnnotation + inrFormatter(d.value.median)
                        + '<br> Q1'+colonAnnotation + inrFormatter(d.value.q1)
                        + '<br> Min'+colonAnnotation + inrFormatter(d.value.min))
                })

            svg.call(y1tip);*/

        // d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
        // var div = d3.select(divId).append('div').attr('class', 'tooltip')
        //     .attr('style', 'position: absolute; opacity: 0;')

    const tooltip = createTooltip(divId);

        // Show the main vertical line
        svg.selectAll('vertLines')
            .data(sumstat)
            .enter()
            .append('line')
            .attr('x1', (d) => {
                return (x1Scale(d.key))
            })
            .attr('x2', (d) => {
                return (x1Scale(d.key))
            })
            .attr('y1', (d) => {
                return (y1Scale(d.value.min))
            })
            .attr('y2', (d) => {
                return (y1Scale(d.value.max))
            })
            .attr('stroke', 'black')
            .style('width', "1px")

        // rectangle for the main box
        var boxWidth = 80
        svg.selectAll('boxes')
            .data(sumstat)
            .enter()
            .append('rect')
            .attr('x', (d) => {
                return (x1Scale(d.key) - boxWidth / 2)
            })
            .attr('y', (d) => {
                return (y1Scale(d.value.q3))
            })
            .attr('height', (d) => {
                return (y1Scale(d.value.q1) - y1Scale(d.value.q3))
            })
            .attr('width', boxWidth)
            .attr('stroke', 'black')
            .style('fill', metric1ColorScale)
            .on('mouseover', function( d) {
                tooltip.onMouseOver(d, this, function(d) {
                    // Tooltip content callback
                    return d.key
                        + '<br> Max' + colonAnnotation + inrFormatter(d.value.max)
                        + '<br> Q3' + colonAnnotation + inrFormatter(d.value.q3)
                        + '<br> Median' + colonAnnotation + inrFormatter(d.value.median)
                        + '<br> Q1' + colonAnnotation + inrFormatter(d.value.q1)
                        + '<br> Min' + colonAnnotation + inrFormatter(d.value.min)
                });  // Pass the event for positioning
            })
            .on('mousemove', function(event) {
                tooltip.onMouseMove(event);  // Update tooltip position on mouse move
            })
            .on('mouseout', function() {
                tooltip.onMouseLeave();  // Hide the tooltip on mouse leave
            })
            .on('contextmenu', function(d) {
                // Determine if we clicked a state or district
                console.log(d)
                const clickedData={
                    [chart.insightNavigator.realDataFieldNames.x1RealDataFieldName]:[d.key]
                }

                console.log("clickedData", clickedData);
                const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);
                contextMenu(menuItems).call(this, clickedData);
                d3.event.preventDefault();
            })

        // Show the median
        svg.selectAll('medianLines')
            .data(sumstat)
            .enter()
            .append('line')
            .attr('x1', (d) => {
                return (x1Scale(d.key) - boxWidth / 2)
            })
            .attr('x2', (d) => {
                return (x1Scale(d.key) + boxWidth / 2)
            })
            .attr('y1', (d) => {
                return (y1Scale(d.value.median))
            })
            .attr('y2', (d) => {
                return (y1Scale(d.value.median))
            })
            .attr("stroke", chart.vizSpecific4)
            .style('width', '1px')

        // Show the mean
        svg.selectAll("meanLines")
            .data(sumstat)
            .enter()
            .append("line")
            .attr("x1", (d) => {
                return (x1Scale(d.key) - boxWidth / 2)
            })
            .attr("x2", (d) => {
                return (x1Scale(d.key) + boxWidth / 2)
            })
            .attr("y1", (d) => {
                return (y1Scale(d.value.mean))
            })
            .attr("y2", (d) => {
                return (y1Scale(d.value.mean))
            })
            .attr("stroke", chart.vizSpecific5)
            .style("width", 80)

        // Add individual points with jitter
        var jitterWidth = chart.vizSpecific1
        svg.selectAll('indPoints')
            .data(data)
            .enter()
            .append('circle')
            .attr('cx', (d) => {
                return (x1Scale(d.dim1_name) - jitterWidth / 2 + Math.random() * jitterWidth)
            })
            .attr('cy', (d) => {
                return (y1Scale(d.metric1))
            })
            .attr('r', 4)
            .style('fill', 'white')
            .attr('stroke', 'black')
    // })
}
